import { render, staticRenderFns } from "./block-pagination.vue?vue&type=template&id=f753d736&scoped=true"
import script from "./block-pagination.vue?vue&type=script&lang=js"
export * from "./block-pagination.vue?vue&type=script&lang=js"
import style0 from "./block-pagination.vue?vue&type=style&index=0&id=f753d736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753d736",
  null
  
)

export default component.exports